import { HttpClient, HttpEventType, HttpRequest } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from '../../environments/environment';
import { GroupTitleProperties } from '../Models/GroupTitleProperties';
import { GroupTitleService } from '../Services/group-title.service';
@Component({
  selector: 'app-add-group-title',
  templateUrl: './add-group-title.component.html',
  styleUrls: ['./add-group-title.component.css'],
})
export class AddGroupTitleComponent implements OnInit {

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  editIcon = faEdit;
  deleteIcon = faTrash;
  visible: boolean = false;
  groupTitleSubmitted: boolean = false;
  obj: GroupTitleProperties = new GroupTitleProperties(); // Initialize your model instance
  imagePlaceHolder: string = "assets/img/Group 430.svg";
  imageSource: string = "";
  baseUrl = environment.baseUrl;
  groupTitleList: GroupTitleProperties[] = [];
  groupTitleError: boolean = false;
  groupImageError: boolean = false;

  constructor(private groupTitleService: GroupTitleService, private http: HttpClient, private confirmationService: ConfirmationService, private messageService: MessageService) { }

  ngOnInit() {
    this.getAllGroupData();
  }

  showDialog() {
    this.visible = true;
    this.obj = new GroupTitleProperties();
    this.imageSource = this.imagePlaceHolder;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      let response = "";
      let responseSplit;
      let firstResponsePart;
      let secondResponsePart;
      let responseCheck;
      const reader = new FileReader();
      reader.onload = (e: any) => {

        this.imageSource = e.target.result;

      };
      reader.readAsDataURL(file);

      const formData = new FormData();

      formData.append(file.name, file);

      const uploadReq = new HttpRequest('POST', this.baseUrl + '/GroupTitle/UploadFile', formData);

      this.http.request(uploadReq).subscribe(event => {
        if (event.type === HttpEventType.Response) {
          response = event.body.toString();
          responseSplit = response.split("\"");
          firstResponsePart = responseSplit[0];
          secondResponsePart = firstResponsePart.split("/,/");
          responseCheck = secondResponsePart[0];
          if (responseCheck == "Uploaded") {
            this.obj.groupImageName = secondResponsePart[2];
            this.obj.groupImagePath = secondResponsePart[1];

            const statusErrorElement = document.getElementById("statusMsg");
            statusErrorElement.style.display = "block";
            statusErrorElement.style.color = "green";

            statusErrorElement.innerHTML = "File uploaded successfully!";
            setTimeout(() => {
              statusErrorElement.style.display = "none";
              statusErrorElement.innerHTML = "";
            }, 3000);

          }

          else {

            const statusErrorElement = document.getElementById("statusMsg");
            statusErrorElement.style.display = "block";
            statusErrorElement.style.color = "red";

            statusErrorElement.innerHTML = "Something went wrong. Please Try Later!";
            setTimeout(() => {
              statusErrorElement.style.display = "none";
              statusErrorElement.innerHTML = "";
            }, 3000);

            return false;
          }
        }
      });
    }
  }

  onSubmit() {

    this.groupTitleSubmitted = true;
    this.groupTitleError = false;
    this.groupImageError = false;
    if (this.obj.groupTitle != undefined) {
      this.obj.groupTitle = this.obj.groupTitle.trim();
      if (this.obj.groupTitle === "") {
        this.groupTitleError = true;

        const groupTitleErrorElement = document.getElementById("groupTitleMsg");
        groupTitleErrorElement.style.display = "block";
        groupTitleErrorElement.style.color = "red";

        groupTitleErrorElement.innerHTML = "Group title cannot be null!";
        setTimeout(() => {
          groupTitleErrorElement.style.display = "none";
          groupTitleErrorElement.innerHTML = "";
        }, 3000);

      }
    }
    else {

      this.groupTitleError = true;

      const groupTitleErrorElement = document.getElementById("groupTitleMsg");
      groupTitleErrorElement.style.display = "block";
      groupTitleErrorElement.style.color = "red";

      groupTitleErrorElement.innerHTML = "Group title cannot be null!";
      setTimeout(() => {
        groupTitleErrorElement.style.display = "none";
        groupTitleErrorElement.innerHTML = "";
      }, 3000);
    }

    if (!this.obj.groupImageName) {
      this.groupImageError = true;


      const groupImageErrorElement = document.getElementById("groupImageMsg");
      groupImageErrorElement.style.display = "block";
      groupImageErrorElement.style.color = "red";

      groupImageErrorElement.innerHTML = "Group image required!!";
      setTimeout(() => {
        groupImageErrorElement.style.display = "none";
        groupImageErrorElement.innerHTML = "";
      }, 3000);
    }

    if (!this.groupTitleError && !this.groupImageError) {

      if (this.obj.groupTitleId > 0) {
        this.groupTitleService.EditGroupTitle(this.obj).subscribe(
          data => {
            if (data) {
              this.visible = false;
              this.obj = new GroupTitleProperties();

              // Clear the file input field
              this.groupTitleSubmitted = false;
              //this.fileInput.nativeElement.value = '';
              this.imageSource = this.imagePlaceHolder;
              this.getAllGroupData();

            }
            else {

              const statusErrorElement = document.getElementById("statusMsg");
              statusErrorElement.style.display = "block";
              statusErrorElement.style.color = "red";

              statusErrorElement.innerHTML = "Something went wrong. Please Try Later!";
              setTimeout(() => {
                statusErrorElement.style.display = "none";
                statusErrorElement.innerHTML = "";
              }, 3000);
            }
          })
      }
      else {

        this.groupTitleService.CreateGroupTitle(this.obj).subscribe(
          data => {
            if (data) {
              this.visible = false;
              this.obj = new GroupTitleProperties();

              // Clear the file input field

              this.groupTitleSubmitted = false;
              this.fileInput.nativeElement.value = '';
              this.imageSource = this.imagePlaceHolder;
              this.getAllGroupData();

            }
            else {
              const statusErrorElement = document.getElementById("statusMsg");
              statusErrorElement.style.display = "block";
              statusErrorElement.style.color = "red";

              statusErrorElement.innerHTML = "Something went wrong. Please Try Later!";
              setTimeout(() => {
                statusErrorElement.style.display = "none";
                statusErrorElement.innerHTML = "";
              }, 3000);
            }
          })
      }
    }


    //  if (this.obj.groupTitle && this.obj.groupImageName) {


    //    //if (this.obj.groupTitleId > 0) {
    //    //  this.groupTitleService.EditGroupTitle(this.obj).subscribe(
    //    //    data => {
    //    //      if (data) {
    //    //        this.visible = false;
    //    //        this.obj = new GroupTitleProperties();

    //    //        // Clear the file input field

    //    //        this.groupTitleSubmitted = false;
    //    //        this.fileInput.nativeElement.value = '';
    //    //        this.imageSource = this.imagePlaceHolder;
    //    //        this.getAllGroupData();

    //    //      }
    //    //      else {
    //    //        $("#statusMsg").show();
    //    //        $("#statusMsg").css("color", "red")
    //    //        document.getElementById("statusMsg").innerHTML = "Something went wrong. Please Try Later."
    //    //        $("#statusMsg").delay(5000).hide(10);
    //    //      }
    //    //    })
    //    //}
    //    //else {
    //    //  //this.groupTitleService.CreateGroupTitle(this.obj).subscribe(
    //    //  //  data => {
    //    //  //    if (data) {
    //    //  //      this.visible = false;
    //    //  //      this.obj = new GroupTitleProperties();

    //    //  //      // Clear the file input field

    //    //  //      this.groupTitleSubmitted = false;
    //    //  //      this.fileInput.nativeElement.value = '';
    //    //  //      this.imageSource = this.imagePlaceHolder;
    //    //  //      this.getAllGroupData();

    //    //  //    }
    //    //  //    else {
    //    //  //      $("#statusMsg").show();
    //    //  //      $("#statusMsg").css("color", "red")
    //    //  //      document.getElementById("statusMsg").innerHTML = "Something went wrong. Please Try Later."
    //    //  //      $("#statusMsg").delay(5000).hide(10);
    //    //  //    }
    //    //  //  })
    //    //}

    //  //} else {


    //  //}
    //}
  }


  onEditClick(data) {
    this.visible = true;
    this.obj.groupTitleId = data.groupTitleId;
    this.obj.groupTitle = data.groupTitle;
    this.obj.groupImageName = data.groupImageName;
    this.obj.groupImagePath = data.groupImagePath;
    this.imageSource = 'data:image/jpg;base64,' + data.imageFile;
  }

  onDeleteClick(data: GroupTitleProperties) {

    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptIcon: "none",
      rejectIcon: "none",

      accept: () => {
        ////console.log ("Delete Confirmed");
        this.DeleteGroupTitle(data.groupTitleId);
        this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted' });
      },
      reject: () => {
        //console.log ("Delete Rejected");
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
      }
    });

    
  }

  getAllGroupData() {
    this.groupTitleService.GetAllGroupTitle().subscribe(
      data => {
        // //console.log (data)
        this.groupTitleList = [];
        this.groupTitleList = data;
      }
        )
  }

  DeleteGroupTitle(groupTitleId: number) {

    this.groupTitleService.DeleteGroupTitle(groupTitleId).subscribe(
      data => {
        if (data) {
          this.getAllGroupData();
          this.visible = false;
          this.obj = new GroupTitleProperties();

          // Clear the file input field

          this.groupTitleSubmitted = false;
          // this.fileInput.nativeElement.value = '';
          this.imageSource = this.imagePlaceHolder;
        }
        else {


          const statusErrorElement = document.getElementById("statusMsg");
          statusErrorElement.style.display = "block";
          statusErrorElement.style.color = "red";

          statusErrorElement.innerHTML = "Something went wrong. Please Try Later.";
          setTimeout(() => {
            statusErrorElement.style.display = "none";
            statusErrorElement.innerHTML = "";
          }, 3000);



        }
      })

  }

}

